export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

export function addEntityProperty(entity: any) {
  addNumProperty(entity, 'yearslost');
  addNumProperty(entity, 'servicetenure');
}

function addNumProperty(entity: any, field: string) {
  let numField = '';
  if (entity[field]) {
    const currentYear = (new Date()).getFullYear();
    const dateYear = (new Date(entity[field])).getFullYear();
    numField = `${currentYear - dateYear}`;
  }
  entity[`${field}Num`] = numField;
}

export function getFullUrl(){
  return window.location.href
}

export function initSessionName() {
  const filterSessionName = 'lndscp-filter';
  const env = getBaseUrl().split('//')[1].split('.')[0].split(':')[0];
  return `${filterSessionName}.${env}`;
}

export const sfdcAccountFilters = [
  'code',
  'sfdcglobalid',
  'accountID',
  'casesafeid'
];

export function transferColorRgba(color: string, opacity: number) {
  const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
  if (color && reg.test(color)) {
    if (color.length === 4) {
      let newColor = '#';
      for (let i = 1; i < 4; i += 1) {
        newColor += color.slice(i, i + 1).concat(color.slice(i, i + 1));
      }
      color = newColor;
    }

    let colors = [];
    for (let i = 1; i < 7; i += 2) {
      colors.push(parseInt('0x' + color.slice(i, i + 2)));
    }
    return `rgba(${colors.join(',')}, ${opacity || 1})`;
  }
  return color;
}

export function isDevEnv() {
  const env = getBaseUrl().split('//')[1].split('.')[0].split(':')[0];
  const devEnvs = ['estate-maps-dev', 'localhost'];
  return devEnvs.includes(env);
}
